module.exports = __webpack_public_path__ + "img/ic_telefon.0935804a.svg";